import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import AccessibilityWidget from './components/common/AccessibilityWidget';
import reportWebVitals from './reportWebVitals';

const basename = process.env.REACT_APP_BASENAME || "/dl/public-portal";

// Render main app inside #root WITH BrowserRouter
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Create a separate container for accessibility widget OUTSIDE #root
const widgetContainer = document.createElement('div');
widgetContainer.id = 'accessibility-widget-container';
document.body.appendChild(widgetContainer);

// Render accessibility widget in the separate container
const widgetRoot = ReactDOM.createRoot(widgetContainer);
widgetRoot.render(<AccessibilityWidget />);

reportWebVitals();